import { jsx } from "react/jsx-runtime";
import { createCollection } from "@tamagui/collection";
import { createContextScope } from "@tamagui/create-context";
import * as React from "react";
import { ToastImperativeProvider } from "./ToastImperative";
const PROVIDER_NAME = "ToastProvider";
const [Collection, useCollection, createCollectionScope] = createCollection("Toast");
const [createToastContext, createToastScope] = createContextScope("Toast", [
  createCollectionScope
]);
const [ToastProviderProvider, useToastProviderContext] = createToastContext(PROVIDER_NAME);
const ToastProvider = (props) => {
  const {
    __scopeToast,
    id: providedId,
    burntOptions,
    native,
    notificationOptions,
    label = "Notification",
    duration = 5e3,
    swipeDirection = "right",
    swipeThreshold = 50,
    children
  } = props;
  const id = providedId ?? React.useId();
  const [viewports, setViewports] = React.useState({});
  const [toastCount, setToastCount] = React.useState(0);
  const isFocusedToastEscapeKeyDownRef = React.useRef(false);
  const isClosePausedRef = React.useRef(false);
  const handleViewportChange = React.useCallback(
    (name, viewport) => {
      setViewports((prev) => ({ ...prev, [name]: viewport }));
    },
    []
  );
  const options = React.useMemo(() => {
    return {
      duration,
      burntOptions,
      native,
      notificationOptions
    };
  }, [JSON.stringify([duration, burntOptions, native, notificationOptions])]);
  return /* @__PURE__ */ jsx(Collection.Provider, { scope: __scopeToast, children: /* @__PURE__ */ jsx(
    ToastProviderProvider,
    {
      scope: __scopeToast,
      id,
      label,
      duration,
      swipeDirection,
      swipeThreshold,
      toastCount,
      viewports,
      onViewportChange: handleViewportChange,
      onToastAdd: React.useCallback(() => {
        setToastCount((prevCount) => prevCount + 1);
      }, []),
      onToastRemove: React.useCallback(() => {
        setToastCount((prevCount) => prevCount - 1);
      }, []),
      isFocusedToastEscapeKeyDownRef,
      isClosePausedRef,
      children: /* @__PURE__ */ jsx(ToastImperativeProvider, { options, children })
    }
  ) });
};
ToastProvider.propTypes = {
  label(props) {
    if (props.label && typeof props.label === "string" && !props.label.trim()) {
      const error = `Invalid prop \`label\` supplied to \`${PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
      return new Error(error);
    }
    return null;
  }
};
ToastProvider.displayName = PROVIDER_NAME;
export {
  Collection,
  ToastProvider,
  createToastContext,
  createToastScope,
  useCollection,
  useToastProviderContext
};
//# sourceMappingURL=ToastProvider.js.map
